import DataGrid from "components/data-grid/DataGrid";
import {
  setBreadCrumbs,
  setCurrent,
  setNavigationComponents,
} from "features/navigation/navigationSlice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet, useLocation } from "react-router-dom";
import PrimaryButton from "ui/buttons/PrimaryButton";
import { columns } from "./columns";
import { useNavigate } from "react-router-dom";
import DropDownButton from "ui/buttons/DropDownButton";
import { PencilAltIcon, XIcon } from "@heroicons/react/outline";
import Card from "ui/Card";

export default function Outlets() {
  let navigate = useNavigate();
  let dispatch = useDispatch();

  let userData = useSelector((state) => state.data.userData);
  let permissions = userData.permissions;
  const canCreate = permissions?.[0]?.includes("w-inventory");
  const canUpdate = permissions?.[0]?.includes("u-inventory");
  const canDelete = permissions?.[0]?.includes("d-inventory");
  const location = useLocation();
  const isListView =
    location.pathname === "/outlets" || location.pathname === "/outlets/";

  React.useEffect(() => {
    if (permissions && permissions[0].length > 0) {
      if (!permissions[0].includes("r-inventory")) {
        navigate("/401");
      }
    }
  }, []);

  React.useEffect(() => {
    dispatch(
      setCurrent({
        name: "Inventories",
      })
    );

    // Only control navigation + breadcrumbs on the main list view.
    // Child routes (add/edit/view) provide their own breadcrumbs.
    if (isListView) {
      dispatch(
        setNavigationComponents(
          canCreate ? (
            <PrimaryButton
              title="Add Warehouse"
              onClick={() => navigate("/outlets/add")}
            />
          ) : null
        )
      );

      dispatch(
        setBreadCrumbs([
          {
            name: "Home",
            path: "/home",
          },
          {
            name: "Inventories",
            path: "/outlets",
          },
        ])
      );
    } else {
      // For nested routes, clear navigation; breadcrumbs come from child.
      dispatch(setNavigationComponents(null));
    }
  }, [dispatch, navigate, isListView, canCreate]);

  const cellFunction = (cell) => {
    if (cell.column.id === "name") {
      return (
        <div
          onClick={() => {
            navigate("/outlets/view/" + cell.row.original.id, {
              state: cell.row.original,
            });
          }}
          className="flex flex-row items-center space-x-3 cursor-pointer"
        >
          <p className="hover:underline">{cell.value}</p>
        </div>
      );
    }
    if (cell.column.id === "actions") {
      const items = [
        ...(canUpdate
          ? [
              {
                title: "Edit",
                icon: <PencilAltIcon className="h-5 w-5" />,
                path: "/outlets/edit/" + cell.row.original.id,
                state: cell.row.original,
              },
            ]
          : []),
        ...(canDelete
          ? [
              {
                title: "Delete",
                icon: <XIcon className="h-5 w-5" />,
                path: "/outlets/delete/" + cell.row.original.id,
                state: cell.row.original,
              },
            ]
          : []),
      ];

      if (items.length === 0) return null;

      return (
        <DropDownButton
          items={items}
          title="Actions"
          icon={<i className="fas fa-ellipsis-v"></i>}
          className=""
          setSelected={(item) => {
            console.log(item);
          }}
          path="/outlets/"
        />
      );
    }
    return cell.value;
  };

  return (
    <div className="relative overflow-scroll min-h-[80vh] ">
      <Card
        heading={"All Inventories"}
        description={"Type in the search field below to search for a inventory"}
      >
        <div className="relative flex space-y-3 flex-col w-full">
          <DataGrid
            searchable={true}
            x_columns={columns}
            height={"h-[calc(100vh-230px)]"}
            api={"/admin/user-groups"}
            showHeader={true}
            cellFunction={cellFunction}
          />
        </div>
      </Card>
      <Outlet />
    </div>
  );
}
